var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"main-header"},[_c('div',{staticClass:"title"},[_c('h2',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"address"},[_c('span',[_vm._v("发布时间："+_vm._s(_vm.time))])])]),_c('div',{staticClass:"main-box"},[_c('CommonVideo',{attrs:{"src":_vm.address}})],1),_c('div',{staticStyle:{"height":"200px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }